import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dayforceKeys } from './keys'
import {
  cancelContestedHoursRequest,
  type CancelContestedHoursRequest,
} from 'api/admin/dayforce/cancelContestedHoursRequest'

export const useCancelContestedHoursRequestMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: CancelContestedHoursRequest) =>
      cancelContestedHoursRequest(request),
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      }),
  })
}
